import { useCallback, useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { useAppContext } from '@interlayer/js/components/system/App/buzz/context';
import { EVENT_PAGE_INFO_READY } from '@interlayer/js/components/system/App/buzz/constants';

const removePreloader = () => document.getElementById('preloader')?.remove();

export const useTogglePreloader = () => {
    const { isAppContext } = useAppContext();
    const [isPageInfoReady, setIsPageInfoReady] = useState(false);
    const [isInitialResourcesReady, setIsInitialResourcesReady] = useState(false);

    useEffect(() => {
        const handlerSetIsPageInfoReady = () => setIsPageInfoReady(true);

        dispatcher.listen(EVENT_PAGE_INFO_READY, handlerSetIsPageInfoReady);

        return () => {
            dispatcher.removeListener(EVENT_PAGE_INFO_READY, handlerSetIsPageInfoReady);
        };
    }, []);

    useEffect(() => {
        if (!isInitialResourcesReady || !isPageInfoReady) {
            return;
        }

        removePreloader();
    }, [isInitialResourcesReady, isPageInfoReady]);

    return useCallback((isReady) => {
        if (!isReady) {
            return;
        }

        if (!isAppContext) {
            removePreloader();
        }

        setIsInitialResourcesReady(true);
    }, [isAppContext]);
};
